<script setup lang="ts">
/**
 * @author Beka Chkhaidze
 */
import { ref, computed } from "vue";

import BaseModal from "@/components/regularComponents/UIComponents/Modals/BaseModal.vue";
import BookingForm from "@/components/regularComponents/FormComponents/BookingForm.vue";

const emit = defineEmits(["close"]);
const isSubmited = ref(false);
const isSuccess = ref(false);

const modalTitle = computed(() => {
  if (!isSubmited.value) return "Request";
  return isSuccess.value ? "Meeting Scheduled" : "Meeting Error";
});

const onUpdate = (e: { isSubmited: boolean; isSuccess: boolean }) => {
  isSubmited.value = e.isSubmited;
  isSuccess.value = e.isSuccess;
};

const onClose = () => {
  emit("close");
};
</script>

<template>
  <div class="footer__book-call">
    <BaseModal class="booking-modal" :title="modalTitle" @close="onClose">
      <Transition name="fade" mode="out-in">
        <BookingForm
          @close="onClose"
          @update="onUpdate"
          formType="requestCalls"
        />
      </Transition>
    </BaseModal>
  </div>
</template>
